var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"itemCd sort-item"},[_c('dt',[_vm._v(_vm._s(_vm.$t('common.labels.productCode')))]),_c('dd',[_vm._v(_vm._s(_vm.ptInitData.productInfo.S_ITEM_NO))])])}
var staticRenderFns = []

export { render, staticRenderFns }